import {Component, inject} from '@angular/core'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {RouterLink} from '@angular/router'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {MatIconButton} from '@angular/material/button'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {environment} from '../../../environments/environment'
import {ADMIN_ROLE_NAME} from '../../application/app'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    LogoComponent,
    MatIconButton,
    ToggleButtonComponent,
    RouterLink
  ]
})
export class HeaderComponent {
  protected readonly service = inject(ConfigService)
  protected readonly environment = environment
  protected readonly ADMIN_ROLE_NAME = ADMIN_ROLE_NAME
}
